import { useState, useEffect, useContext } from "react";
import AWS from "aws-sdk";
import { AWSContext } from "../GlobalContext/AWSContext";

const FetchSignedUrl = ({ path, onUrlGenerated }) => {
    const [signedUrl, setSignedUrl] = useState("");
    const objectKey = path;
    // const { accessKey, secretKey, bucket, region } = useContext(AWSContext);
    const contextData = useContext(AWSContext);

    useEffect(() => {
        AWS.config.update({
            accessKeyId: contextData?.accessKey,
            secretAccessKey: contextData?.secretKey,
            region: contextData?.region,
        });

        const s3 = new AWS.S3();

        const params = {
            Bucket: contextData?.bucket,
            Key: objectKey,
            Expires: 900,
        };

        s3.getSignedUrl("getObject", params, (err, url) => {
            if (err)
            {
                console.error("Error generating pre-signed URL", err);
            } else
            {
                setSignedUrl(url);
                if (onUrlGenerated)
                {
                    onUrlGenerated(url);
                }
            }
        });
    }, [
        path,
        contextData?.accessKey,
        contextData?.secretKey,
        contextData?.region,
        contextData?.bucket,
        objectKey,
        onUrlGenerated,
    ]);

    return signedUrl;
};

export default FetchSignedUrl;

